"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var tools_1 = require("../../../utils/tools");
var prosemirror_state_1 = require("prosemirror-state");
var LineIndentUtil = /** @class */ (function () {
    function LineIndentUtil(editor) {
        var _this = this;
        this.name = 'line_indent';
        this.isActive = false;
        this.active = function (editor) {
            _this.isActive = Boolean(_this.getCurAttr());
            return _this.isActive;
        };
        this.disable = function (editor) {
            var selection = editor.view.state.selection;
            return (!(selection instanceof prosemirror_state_1.AllSelection) &&
                !tools_1.checkParentSupportAttr(editor.view, 'lineIndent'));
        };
        this.handler = function (editor) {
            var lineIndent = _this.isActive ? 0 : 2;
            var _a = editor.view, dispatch = _a.dispatch, state = _a.state;
            var tr = state.tr;
            editor.nodesBetween(function (node, pos) {
                if (node.isTextblock) {
                    tr = tr.setNodeMarkup(pos, undefined, __assign(__assign({}, node.attrs), { lineIndent: lineIndent }));
                    return false;
                }
            });
            dispatch(tr);
            editor.focus();
        };
        this.editor = editor;
    }
    LineIndentUtil.prototype.getCurAttr = function () {
        var node = this.editor.view.state.selection.$from.node();
        if (!node)
            return false;
        return node.attrs.lineIndent;
    };
    return LineIndentUtil;
}());
exports.LineIndentUtil = LineIndentUtil;
//# sourceMappingURL=line-indent-util.js.map